/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MySQLLeadIntegrationData
 */
export interface MySQLLeadIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MySQLLeadIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MySQLLeadIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MySQLLeadIntegrationData
     */
    paused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    databaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    tableName?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    customWhere?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    categoryColumns?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnVerified?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmMedium?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmContent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnClickId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmCampaign?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmCampaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmAdSetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationData
     */
    columnUtmAdSetAdId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MySQLLeadIntegrationData
     */
    passwordConfigured?: boolean;
}

/**
 * Check if a given object implements the MySQLLeadIntegrationData interface.
 */
export function instanceOfMySQLLeadIntegrationData(value: object): value is MySQLLeadIntegrationData {
    return true;
}

export function MySQLLeadIntegrationDataFromJSON(json: any): MySQLLeadIntegrationData {
    return MySQLLeadIntegrationDataFromJSONTyped(json, false);
}

export function MySQLLeadIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MySQLLeadIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] === undefined ? undefined : json['lastRegularUpdate'] === null ? null : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] === undefined ? undefined : json['lastHistoricalUpdate'] === null ? null : json['lastHistoricalUpdate'],
        'paused': json['paused'] == null ? undefined : json['paused'],
        'project': json['project'] == null ? undefined : json['project'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customWhere': json['customWhere'] === undefined ? undefined : json['customWhere'] === null ? null : json['customWhere'],
        'categoryColumns': json['categoryColumns'] === undefined ? undefined : json['categoryColumns'] === null ? null : json['categoryColumns'],
        'columnDate': json['columnDate'] == null ? undefined : json['columnDate'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'columnCountry': json['columnCountry'] === undefined ? undefined : json['columnCountry'] === null ? null : json['columnCountry'],
        'columnVerified': json['columnVerified'] === undefined ? undefined : json['columnVerified'] === null ? null : json['columnVerified'],
        'columnUtmSource': json['columnUtmSource'] === undefined ? undefined : json['columnUtmSource'] === null ? null : json['columnUtmSource'],
        'columnUtmMedium': json['columnUtmMedium'] === undefined ? undefined : json['columnUtmMedium'] === null ? null : json['columnUtmMedium'],
        'columnUtmContent': json['columnUtmContent'] === undefined ? undefined : json['columnUtmContent'] === null ? null : json['columnUtmContent'],
        'columnClickId': json['columnClickId'] === undefined ? undefined : json['columnClickId'] === null ? null : json['columnClickId'],
        'columnUtmCampaign': json['columnUtmCampaign'] === undefined ? undefined : json['columnUtmCampaign'] === null ? null : json['columnUtmCampaign'],
        'columnUtmCampaignId': json['columnUtmCampaignId'] === undefined ? undefined : json['columnUtmCampaignId'] === null ? null : json['columnUtmCampaignId'],
        'columnUtmAdSetId': json['columnUtmAdSetId'] === undefined ? undefined : json['columnUtmAdSetId'] === null ? null : json['columnUtmAdSetId'],
        'columnUtmAdSetAdId': json['columnUtmAdSetAdId'] === undefined ? undefined : json['columnUtmAdSetAdId'] === null ? null : json['columnUtmAdSetAdId'],
        'passwordConfigured': json['passwordConfigured'] == null ? undefined : json['passwordConfigured'],
    };
}

export function MySQLLeadIntegrationDataToJSON(json: any): MySQLLeadIntegrationData {
    return MySQLLeadIntegrationDataToJSONTyped(json, false);
}

export function MySQLLeadIntegrationDataToJSONTyped(value?: MySQLLeadIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'paused': value['paused'],
        'project': value['project'],
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'databaseName': value['databaseName'],
        'tableName': value['tableName'],
        'domain': value['domain'],
        'customWhere': value['customWhere'],
        'categoryColumns': value['categoryColumns'],
        'columnDate': value['columnDate'],
        'timeZone': value['timeZone'],
        'columnCountry': value['columnCountry'],
        'columnVerified': value['columnVerified'],
        'columnUtmSource': value['columnUtmSource'],
        'columnUtmMedium': value['columnUtmMedium'],
        'columnUtmContent': value['columnUtmContent'],
        'columnClickId': value['columnClickId'],
        'columnUtmCampaign': value['columnUtmCampaign'],
        'columnUtmCampaignId': value['columnUtmCampaignId'],
        'columnUtmAdSetId': value['columnUtmAdSetId'],
        'columnUtmAdSetAdId': value['columnUtmAdSetAdId'],
        'passwordConfigured': value['passwordConfigured'],
    };
}

